module.exports = __webpack_public_path__ + "img/cover_1.c6f313c3.png";